import React from 'react';
import moment from 'moment';
import { Table, TableBody, TableCell, TableRow, TableHead, CircularProgress, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, Drawer, TextField, withStyles } from '@material-ui/core';
import { printTicket } from '../helpers/utils';
import { backendUrl } from '../App';
import Print from './Print';
import { clearOrder } from '../actions/orderActions';

const styles = theme => ({
    root: {
        flexGrow: 1,
        height: '100%',
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
    },
    drawerPaper: {
        position: 'relative',
        width: '300px',
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 3,
        minWidth: 0, // So the Typography noWrap works
        overflowY: 'auto'
    }
});

const Tickets = ({classes, ...props}) => {
    const currentDate = moment().format('YYYY-MM-DD');
    const [tickets, setTickets] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [printOrder, setPrintOrder] = React.useState();
    const [detailTicketDialogOpen, setDetailTicketDialogOpen] = React.useState(false);
    const [ticketToDetail, setTicketToDetail] = React.useState();
    const [searchDate, setSearchDate] = React.useState(currentDate);
    const [searchId, setSearchId] = React.useState();
    const [searching, setSearching] = React.useState(false);

    const loadTickets = async (date, id) => {
        const token = sessionStorage.getItem('rtvcrespoToken');

        let url = null;
        if (date) {
            url = `${backendUrl}/orders/all?date=${date}`;
        }
        if (id) {
            url = `${backendUrl}/orders/all?id=${id}`;
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            })
        });
        const tickets = await response.json();

        const orderedTickets = tickets.sort((a, b) => b.id - a.id);

        return orderedTickets;
    }

    const handleChangeFilterDate = async (event) => {
        setSearching(true);
        const newDate = event.target.value;
        const dbTickets = await loadTickets(newDate);
        setSearchDate(newDate);
        setTickets(dbTickets);
        setSearching(false);
    }

    const handleChangeFilterId = async (event) => {
        const newId = event.target.value; 

        setSearching(true);
        setSearchId(newId);
        const dbTickets = await loadTickets(null, newId);
        setTickets(dbTickets);
        setSearching(false);
    }

    const setSelectedTicketToPrint = (ticket) => {
        const newPrintOrder = { ...ticket };
        newPrintOrder.ticketId = newPrintOrder.id;
        setPrintOrder(newPrintOrder);
        setTimeout(() => {
            printTicket(clearOrder);
        }, 100);
    }

    const handleCloseDetailTicketDialog = () => {
        setDetailTicketDialogOpen(false);
    }

    const setSelectedTicketToDetail = (ticket) => {
        setTicketToDetail(ticket);
        setDetailTicketDialogOpen(true);
    }

    const init = async () => {
        setLoading(true);
        try {
            const dbTickets = await loadTickets(searchDate);
            setTickets(dbTickets);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setTickets([]);
            setLoading(false);
        }
    };

    React.useEffect(() => {
        init();
    }, []);



    if (loading) {
        return <CircularProgress size={150} />
    }

    return (
        <React.Fragment>
            <div className={classes.root}>
                <Drawer
                    variant="permanent"
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    <form className={classes.container} noValidate>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '15px'
                            }}
                        >
                            <TextField
                                id="date"
                                label="Fecha"
                                type="date"
                                defaultValue={searchDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={handleChangeFilterDate}
                            />

                            <TextField
                                id="number"
                                label="Nº Ticket"
                                value={searchId}
                                type="number"
                                inputProps={{
                                    step: "1"
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                margin="normal"
                                onChange={handleChangeFilterId}
                            />
                        </div>
                    </form>
                </Drawer>
                <main className={classes.content}>
                    {searching ?
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <CircularProgress size={80} />
                        </div>
                        :
                        <Table >
                            <TableHead>
                                <TableRow>
                                    <TableCell numeric>Nº Ticket</TableCell>
                                    <TableCell numeric>Fecha</TableCell>
                                    <TableCell numeric>Total</TableCell>
                                    <TableCell numeric>Nº Líneas</TableCell>
                                    <TableCell>Acciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <React.Fragment>
                                    {(tickets && tickets.length > 0) &&
                                        <React.Fragment>
                                            {tickets.map(ticket => {
                                                return (
                                                    <TableRow key={ticket.id}>
                                                        <TableCell component="th" scope="row">
                                                            {ticket.id}
                                                        </TableCell>
                                                        <TableCell numeric>
                                                            {moment(ticket.creation_date).format('DD/MM/YYYY HH:mm')}
                                                        </TableCell>
                                                        <TableCell numeric>{ticket.total_amount} €</TableCell>
                                                        <TableCell numeric>{ticket.lines.length}</TableCell>
                                                        <TableCell>
                                                            <IconButton
                                                                aria-label="print"
                                                                onClick={() => setSelectedTicketToPrint(ticket)}
                                                            >
                                                                <i className="fas fa-print"></i>
                                                            </IconButton>

                                                            <IconButton
                                                                aria-label="print"
                                                                onClick={() => setSelectedTicketToDetail(ticket)}
                                                            >
                                                                <i className="fas fa-info-circle "></i>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            </TableBody>
                        </Table>
                    }
                </main>
            </div>

            <Print order={printOrder} />

            <Dialog
                open={detailTicketDialogOpen}
                onClose={handleCloseDetailTicketDialog}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
            >
                <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
                    Detalle ticket {(ticketToDetail && ticketToDetail.id) ? ticketToDetail.id : ''}
                </DialogTitle>
                <DialogContent style={{ textAlign: 'center' }}>
                    {ticketToDetail &&
                        <React.Fragment>
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell numeric>Producto</TableCell>
                                        <TableCell numeric>Cantidad</TableCell>
                                        <TableCell numeric>Precio/Ud</TableCell>
                                        <TableCell numeric>Precio/Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(ticketToDetail.lines.length > 0) &&
                                        <React.Fragment>
                                            {ticketToDetail.lines.map(line => {
                                                return (
                                                    <TableRow key={line.id}>
                                                        <TableCell component="th" scope="row">
                                                            {`${line.title} ${line.model}`}
                                                        </TableCell>
                                                        <TableCell numeric>
                                                            {line.quantity}
                                                        </TableCell>
                                                        <TableCell numeric>
                                                            {line.price} €
                                                        </TableCell>
                                                        <TableCell numeric>
                                                            {line.price * line.quantity} €
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </React.Fragment>
                                    }
                                </TableBody>
                            </Table>

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    marginTop: '15px'
                                }}
                            >
                                <Typography variant={'title'}>
                                    Total: {ticketToDetail.total_amount}€
                                </Typography>
                            </div>
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDetailTicketDialog} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default withStyles(styles)(Tickets);


// WEBPACK FOOTER //
// ./src/components/Tickets.js